import CircularProgress from "@mui/material/CircularProgress";
import styled, { keyframes } from "styled-components";

import * as SVGIcons from "../../../../../../assets/iconsSVG";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled(SVGIcons.SpinnerIcon)`
  display: inline-block;
  animation: ${rotate} 2s linear infinite;
`;

export const Container: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-width: ${(props: any) => (props?.focused ? 2 : 1)}px;
  border-radius: 4px;
  border-color: ${(props: any) => (props?.focused ? "blue" : "#d5d5d5")};
  border-style: solid;
  height: 40px;
  padding: 0 4px 0 15px;
`;

export const LoadingIcon = styled(CircularProgress)``;

export const CustomInput = styled.input`
  border: none !important;
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #333333;
  transition: all 0.3s ease; /* Add a transition for the width property */
  &:hover {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
  }
  &:focus {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
  }
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props: any) => props?.color};
  margin-right: 15px;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: row;
  width: 30px;
  align-items: center;
  justify-content: center;
`;

export const TextStatus: any = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  margin-top: 8px;
  color: ${(props: any) => props.color};
`;

export const Label: any = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 150%;
  color: #333333;
`;
